<template>
  <time v-if="!!date" :datetime="date">{{ date }}</time>
</template>

<script>
import { defineComponent, computed } from '@vue/composition-api'
import { parse,parseISO, format, isDate } from 'date-fns'

import { DATE_FORMAT } from '@constants'

export default defineComponent({
  name: 'FormattedDate',
  props: {
    value: String,
    default: null
  },
  setup(props) {
    const date = computed(() => {
      if (!isDate(props.value)) {
        const parsedDate = parse(props.value)        

        if(parsedDate.getFullYear() < 2000) {
          return null
        }

        return format(parsedDate, DATE_FORMAT)
        
      }

      return format(props.value, DATE_FORMAT)
    })

    return {
      date
    }
  }
})
</script>
